var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsEnum, IsNotEmpty, IsObject, IsOptional, IsString, } from 'class-validator';
import { Feedback } from '../../enums/FilterChatOutcomeFeedbackEnum';
/**
 * In order to validate filterParams, we should use the @IsObject() decorator,
 * but for the reason explained in the shipmentFilter declaration
 * it's not currently working as expected.
 */
var ShipmentFilterDto = /** @class */ (function () {
    function ShipmentFilterDto() {
    }
    return ShipmentFilterDto;
}());
var FilterChatOutcomeInput = /** @class */ (function () {
    function FilterChatOutcomeInput() {
    }
    __decorate([
        IsNotEmpty(),
        IsString(),
        __metadata("design:type", String)
    ], FilterChatOutcomeInput.prototype, "chatId", void 0);
    __decorate([
        IsNotEmpty(),
        IsEnum(Feedback),
        __metadata("design:type", String)
    ], FilterChatOutcomeInput.prototype, "feedback", void 0);
    __decorate([
        IsOptional(),
        IsString({ each: true }),
        __metadata("design:type", Array)
    ], FilterChatOutcomeInput.prototype, "feedbackText", void 0);
    __decorate([
        IsOptional(),
        IsObject(),
        __metadata("design:type", ShipmentFilterDto)
    ], FilterChatOutcomeInput.prototype, "shipmentFilter", void 0);
    __decorate([
        IsOptional(),
        IsString(),
        __metadata("design:type", String)
    ], FilterChatOutcomeInput.prototype, "searchUrl", void 0);
    __decorate([
        IsNotEmpty(),
        IsString(),
        __metadata("design:type", String)
    ], FilterChatOutcomeInput.prototype, "discussionId", void 0);
    return FilterChatOutcomeInput;
}());
export { FilterChatOutcomeInput };
